<template>
  <div>
    <router-view />
    <Banner background="red" />

    <!-- <UserResume
      :total-courses="numberOfCourses"
      :total-students="3"
      :rating="5"
    /> -->

    <UserAboutView :name="infos[0].firstName + ' ' + infos[0].lastName" />

    <section class="cursos">
      <h1>Cursos</h1>

      <div class="content">
        <div class="cards__container" style="display: flex">
          <div class="novo-curso">
            <router-link :to="routerLink">
              <div class="novo-curso-img__container">
                <img src="@/assets/icons/new-curso.svg" />
              </div>
            </router-link>
          </div>

          <template v-for="(course, index) in courses">
            <CourseView :key="index" :course="course" />
          </template>
        </div>
      </div>
    </section>

    <button @click="() => this.$router.push('/EndersonTeacher/curso/banana')" >Teste curso</button>
    
    <!-- <Testimonials :testimonials="avaliacoes" /> -->
  </div>
</template>

<script>
import Banner from '@/components/atomic/templates/Banner.vue';
// import UserResume from '@/components/atomic/templates/UserResume.vue';
import UserAboutView from '@/components/atomic/templates/UserAboutView.vue';
// import Courses from '@/components/atomic/templates/Courses.vue';
import CourseView from '@/components/atomic/organisms/CourseView';
// import Testimonials from '@/components/atomic/templates/Testimonials.vue';
import axios from 'axios';

export default {
  name: 'LandingPage',

  components: {
    Banner,
    // UserResume,
    UserAboutView,
    // Courses,
    CourseView,
    // Testimonials,
  },

  data() {
    return {
      courses: [],
      infos: {},
      slugs: [],
      //   avaliacoes: [
      //     {
      //       id: '',
      //       img: require('@/assets/avatar/avatar.svg'),
      //       name: 'Luís Carlos',
      //       date: '03 Fev 2021, 10:26 PM',
      //       comment:
      //         'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
      //     },
      //     {
      //       id: '',
      //       img: require('@/assets/avatar/avatar.svg'),
      //       name: 'Luís Carlos',
      //       date: '03 Fev 2021, 10:26 PM',
      //       comment:
      //         'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
      //     },
      //     {
      //       id: '',
      //       img: require('@/assets/avatar/avatar.svg'),
      //       name: 'Luís Carlos',
      //       date: '03 Fev 2021, 10:26 PM',
      //       comment:
      //         'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
      //     },
      //     {
      //       id: '',
      //       img: require('@/assets/avatar/avatar.svg'),
      //       name: 'Luís Carlos',
      //       date: '03 Fev 2021, 10:26 PM',
      //       comment:
      //         'Apesar de eu ter realmente demorado a chegar no fim, é um bom curso. O instrutor passa por todas as etapas do processo de criação e explica cada um deles claramente.',
      //     },
      //   ],
    };
  },

  //   computed: {
  //     numberOfCourses() {
  //       return this.courses.length;
  //     },
  //   },

  async mounted() {
    await this.getAllSlugs();
    let currentSlug = this.$route.params.slug;
    console.log(currentSlug);
    // if (!this.slugs.includes(currentSlug)) {
    //   this.$router.push('/404');
    // }

    // Preechendo cursos
    await this.getAllCourseOfTeacher(currentSlug);

    //Preechendo Infos
    await this.getAllTeachers(currentSlug);
    console.log(this.infos);
    //   .then(() => console.log(this.slugs));
  },
  computed: {},
  methods: {
    // async handleAvaliations() {
    //   this.avaliacoes.filter((avaliacao) => {
    //     this.courses.avaliations.map((a) => {
    //       avaliacao.comment = a.comment;
    //       avaliacao.id = a.id;
    //     });
    //   });
    // },
    async getAllSlugs() {
      try {
        await axios
          .get('http://localhost:3000/user/allTeachers')
          .then((res) => {
            this.slugs = res.data.map((teacher) => {
              return teacher.slug;
            });
            console.log(this.slugs);
          });
      } catch (e) {
        console.log(e);
      }
    },
    async getAllTeachers(currentSlug) {
      try {
        await axios
          .get('http://localhost:3000/user/allTeachers')
          .then((res) => {
            this.infos = res.data.filter(
              (teacher) => teacher.slug == currentSlug
            );
          });
      } catch (e) {
        console.log(e);
      }
    },
    async getAllCourseOfTeacher(currentSlug) {
      try {
        await axios
          .get('http://localhost:3000/user/allTeachers')
          .then((res) => {
            let courses = res.data.filter(
              (teacher) => teacher.slug === currentSlug
            );
            this.$store.state.teacher.name = currentSlug;
            courses[0].courses.forEach((element) => {
              this.courses.push(element);
            });
            console.log(this.courses);
          });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  #resume {
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;

    .position {
      display: none;
    }

    .cards {
      flex-direction: column;
      margin-top: 0;
    }
  }

  #about {
    .main {
      padding: 30px;
      flex-direction: column;

      .personal-infos {
        .nome {
          font-size: 36px;
        }
        .profissao {
          font-size: 24px;
        }

        .location,
        .email,
        .phone {
          font-size: 22px;
        }
      }
    }

    .description {
      display: none;
    }
  }

  #cursos {
    .content {
      display: flex;
      flex-direction: row;
      .novo-curso {
        display: none;
      }

      .cards__container {
        display: flex !important;
      }
    }
  }
}
</style>
